import { render, staticRenderFns } from "./DistributionSettingsComponent.vue?vue&type=template&id=18223a50&scoped=true&"
import script from "./DistributionSettingsComponent.vue?vue&type=script&lang=js&"
export * from "./DistributionSettingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./DistributionSettingsComponent.vue?vue&type=style&index=0&id=18223a50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18223a50",
  null
  
)

export default component.exports